export const MetaPathwayAction_Types_WithProtocols = ['activate-protocol', 'consider-protocol'];
export const MetaPathwayAction_Types_WithoutProtocols = ['h&p', 'restart', 'admit', 'discharge'];
export const MetaPathwayAction_Types = [...MetaPathwayAction_Types_WithProtocols, ...MetaPathwayAction_Types_WithoutProtocols];
//# sourceMappingURL=types.js.map